import styles from "../../object-passport.module.css";

import { Typography } from "antd";

import LinkIcon from "@/icons/LinkIcon";

const CopyLink = () => {
  return (
    <Typography.Paragraph
      className={styles.copyLinkWrap}
      copyable={{
        icon: [
          <LinkIcon className={styles.copyLink} />,
          <LinkIcon className={styles.copyLink} />,
        ],
        tooltips: ["Копировать ссылку", "Ссылка скопирована"],
        text: `${window.location.origin}${window.location.pathname}`, // URL без якорей
      }}
    ></Typography.Paragraph>
  );
};
export default CopyLink;
